export default {"src":"/_next/static/media/alignment_bold.2bd1fba7.svg","height":24,"width":24};